import { Injectable }             from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot }    from '@angular/router';
import { AuthService }            from './auth.service';
import { Role } from 'app/shared/models/role';

@Injectable()
export class AdminGuard implements CanActivate {
    constructor(private authService: AuthService, private router: Router) {}

      canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
          // need to make sure the user is an admin... otherwise redirect them back to the home screen.
          return this.authService.getCurrentUser().then(user => {
              if (user.role < Role.Client) {
                  return true;
              }
              else {
                this.router.navigate(['/loginAdmin'], {
                    queryParams: {
                        return: state.url
                    }
                });
                return false;
              }
          }).catch (error => {
              console.error(error);
              this.router.navigate(['/loginAdmin'], {
                queryParams: {
                    return: state.url
                }
            });

            return false;
          });
      }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        return this.canActivate(route, state);
    }

}



// WEBPACK FOOTER //
// ./src/app/login/services/admin-guard.service.ts